import React from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';

const PREFIX = 'DialogChooseBanner';

const classes = {
  title: `${PREFIX}-title`,
  typography: `${PREFIX}-typography`,
  button: `${PREFIX}-button`
};

const StyledDialog = styled(Dialog)({
  [`& .${classes.title}`]: {
    color: '#F28109',
    fontFamily: 'Works Sans',
  },
  [`& .${classes.typography}`]: {
    color: '#8C97A1',
  },
  [`& .${classes.button}`]: {
    color: '#F28109',
  },
});

const DialogChooseBanner = props => {


  return (
    <StyledDialog
      open={props.open}
      onClose={props.handleClose}
    >
      <DialogTitle className={classes.title}>
          Add a Whiteboard First
      </DialogTitle>
      <DialogContent>
        <Typography className={classes.typography}>
          Please add a whiteboard before adding letters, shapes, or other assets.
        </Typography>
        <DialogActions>
          <Button autoFocus onClick={props.handleClose} className={classes.button}>
            GOT IT
          </Button>
        </DialogActions>
      </DialogContent>
    </StyledDialog>
  );
};

DialogChooseBanner.propTypes = {
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default DialogChooseBanner;
